export function NextButton({ step, onClick, disabled, text, type }) {
  return (
    <>
      <button
        type={type}
        className={`bg-coc-green w-[200px] py-3 ml-auto hover:bg-[#329940] rounded-lg text-white`}
        onClick={onClick}
        disabled={disabled}
      >
        <span className="capitalize">
          {text
            ? text
            : step === 5
            ? "Send For Validation"
            : step === 6
            ? "Finish"
            : "Next step"}
        </span>
      </button>
    </>
  );
}
